import type { InternalRangeItem } from '../types/range-legend.internal.js';

export const getItemsMinMaxValues = (items: InternalRangeItem[]) => {
  const itemValues = items.flatMap((item) => [item.from, item.to]);
  const itemMinValue = Math.min(...itemValues);
  const itemMaxValue = Math.max(...itemValues);

  return { itemMaxValue, itemMinValue };
};
